import {MapComponent} from "../MapComponent";
import App from "../App";

let appComponent: App = undefined;

let mapComponent: MapComponent = undefined;


export const defineAppComponent = (app: App) => {
    appComponent = app;
}

export const getAppComponent = (): App => {
    return appComponent;
}

export const defineMapComponent = (mc: MapComponent) => {
    mapComponent = mc;
}

export const getMapComponent = (): MapComponent => {
    return mapComponent;
}
